import { Cloudinary } from "@cloudinary/url-gen";

const cloudinary = new Cloudinary({
  cloud: {
    cloudName: "hwwm7aibj",
  },
  url: {
    secure: true,
  },
});

export const toImageUrl = (publicId: string): string => {
  return cloudinary.image(publicId).toURL();
};

export const toVideoUrl = (publicId: string): string => {
  return cloudinary.video(publicId).toURL();
};
